import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorHandlerService } from '../error-handler.service';
import { AnimationsService } from '../animations.service';
import { environment } from '../../../environments/environment';
import { API } from '../api';
import { AuthService } from 'src/app/security/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProvaAlunoService {

  constructor(
    private http: HttpClient,
    private animationsService: AnimationsService,
    private errorHandlerService: ErrorHandlerService,
    private authService: AuthService,
  ) { }

  getPorId(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('provaAlunoId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.provaAluno.buscarPorId}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter dados', []))
      );
  }

  buscarPorMatriculaId(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.provaAluno.buscarPorMatriculaId}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter dados', []))
      );
  }

  cadastrar(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.provaAluno.cadastrar}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
      );
  }
  AtualizarStatusProva(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.provaAluno.atualizarStatusProva}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
      );
  }
  informacaoCadastro(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    const params: HttpParams = new HttpParams().set('matriculaId', id);

    return this.http.get(`${environment.baseUrl}${API.provaAluno.informacoesCadastro}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter dados', []))
      );
  }

  BuscarProvasDisponiveis(colegioId, unidadeId, cursoId): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('colegioId', colegioId).set('unidadeId', unidadeId).set('cursoId', cursoId);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.provaAluno.buscarProvasDisponiveis}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter dados', []))
      );
  }

  cadastrarCredenciais(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.provaAluno.cadastrarCredenciais}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao cadastrar credenciais', []))
      );
  }

  cancelarInscricao(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('provaAlunoId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.provaAluno.cancelarInscricao}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao cancelar inscrição', []))
      );
  }

  imprimirFormulario(id): Observable<any> {
    this.animationsService.showProgressBar(true);  
    return this.getPDF(id).pipe(
      tap(data => {
        const blobUrl = URL.createObjectURL(data);
  
        // Abrir uma nova janela ou aba do navegador com o PDF
        const newWindow = window.open(blobUrl);
  
        // Quando o PDF estiver carregado, acionar o comando de impressão
        newWindow.onload = () => {
          newWindow.print();
        };
      })
    );
  }

  getPDF(id: string): Observable<Blob> {
    // Supondo que você precise passar o "id" como parâmetro na solicitação
    const params: HttpParams = new HttpParams().set('provaAlunoId', id);
    const usuario = this.authService.getToken();
    // Substitua 'seu_endpoint_pdf' pelo endpoint correto que retorna o PDF
    return this.http.get(`${environment.baseUrl}${API.provaAluno.imprimirFormulario}`, {
      params,
      responseType: 'blob', headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)
    });
  }

  buscarProvasRealizadas(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.provaAluno.buscarProvasRealizadas}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter dados', []))
      );
  }

  buscarProximaProva(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.provaAluno.buscarProximaProva}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter dados', []))
      );
  }
}
